module.exports = __webpack_public_path__ + "static/media/satheesh.aa0f2aa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/satheesh.jpg
// module id = 188
// module chunks = 0